import { Component, Input } from '@angular/core';
import { TitleCardConfig } from '../card.component';

@Component({
  selector: 'app-title-card-content',
  imports: [],
  templateUrl: './title-card-content.component.html',
  styleUrl: './title-card-content.component.scss',
})
export class TitleCardContentComponent {
  @Input() config!: TitleCardConfig;
}
